import Backbone from 'backbone';
import _ from 'lodash';

const Response = Backbone.Model.extend({
  validate: function (attrs) {
    if (!attrs.answer_id) {
      return 'Must include an answer_id';
    }
  },
  toJSON: function () {
    return { response: _.clone(this.attributes) };
  },
});

export default Response;
